// extracted by mini-css-extract-plugin
export var closeButton = "_88-0";